import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="container-main pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">Contact</span>
          </nav>

          <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6">
            Contact Us
          </h1>

          <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed">
            <p className="text-base mb-6">
              Have questions, feedback, or suggestions for our AllChinaBuy Spreadsheet resources? We would love to hear from you. Please note that we are an independent resource site and cannot help with specific order issues on the AllChinaBuy platform — those should be directed to AllChinaBuy customer support.
            </p>

            <div className="bg-background-100 rounded-lg p-6 border border-background-200/50 mb-6">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">What We Can Help With</h2>
              <ul className="space-y-2 text-sm text-foreground-700">
                <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> Suggestions for new guide topics or articles</li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> Corrections or updates to existing content</li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> General questions about our resources</li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> Feedback on the website or user experience</li>
              </ul>
            </div>

            <div className="bg-primary-50 rounded-lg p-6 border border-primary-200/50 mb-6">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">What We Cannot Help With</h2>
              <ul className="space-y-2 text-sm text-foreground-700">
                <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5" /> Specific order problems or disputes on AllChinaBuy</li>
                <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5" /> Refund requests or payment issues</li>
                <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5" /> Shipping or delivery tracking</li>
                <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5" /> Direct seller communications</li>
              </ul>
              <p className="text-sm text-foreground-600 mt-3">
                For these issues, please contact <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:underline">AllChinaBuy support directly</a>.
              </p>
            </div>

            <p className="text-base mb-6">
              We aim to respond to all inquiries within 3-5 business days. Thank you for helping us improve this resource for the community.
            </p>

            <div className="mt-10 bg-primary-50 rounded-lg p-6 md:p-8 text-center border border-primary-200/50">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Back to Homepage</h3>
              <p className="text-sm text-foreground-600 mb-4">Browse our guides and resources.</p>
              <a href="/" className="btn-primary inline-flex">
                Go to Homepage
                <i className="ri-arrow-right-line ml-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}